import CreditSVG from "@design-system/ui-icons/vanilla/Credit"
import { createIcon } from "../createIcon"

export const CreditIcon = createIcon(CreditSVG)
